import c from './assets/sass/loader.module.scss'

export const Loader = () => {
    return <div className={c.component} />
}
